<div class="authorized">
	<img
		src="./assets/images/icons/authorized.svg"
		alt="whatsapp icon for contact" />
	<p>Autorizados por la <span>CNBV</span></p>
</div>
